import {connect} from "react-redux";
import ActionsList from './ActionsList';
import * as selectors from '../selectors';
import { openCardModal } from '../actions';

const {getBusinessCard , getCardActions } = selectors;

const mapStateToProps = (state) => {
    return {
        actions: getCardActions(state),
        actionsColor: getBusinessCard(state).settings.actionsSettings.color,
        fontColor: getBusinessCard(state).settings.actionsSettings.fontColor
    }
}

const mapDispatchToProps = (dispatch) => {
    return{
        openModal: () => dispatch(openCardModal())
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(ActionsList);